import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-align-left",
  "use": "format-align-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-align-left\"><path fill-rule=\"evenodd\" d=\"M3 15v2h12v-2H3Zm0-8v2h12V7H3Zm18 6v-2H3v2h18Zm0 8v-2H3v2h18ZM3 5h18V3H3v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol